export default {
  outList: [
    {
      light_point_1:[
        {
          title: '齿刃点阵格栅',
          type: 'image',
          video: '',
          image: 'lightPoint/1/tab1-2.jpg',
          text: ''
        },
        {
          title: '全栈自研中国心十佳混动发动机',
          type: 'image',
          video: '',
          image: 'lightPoint/3/tab3-1.jpg',
          text: '1200多公里超长综合续航、每1万公里仅需保养一次、三电终身质保'
        }
      ],
      light_point_3:[
        {
          title: '十佳安全守护，最聪明的磐石车身',
          type: 'image',
          video: '',
          image: 'lightPoint/4/tab4-2.jpg',
          text: '170mm超宽前吸能盒，2.8mm超厚防撞钢梁，航空级铝合金，84%超宽车身横向覆盖率'
        }
      ],
      light_point_4:[
        {
          title: '追猎贯穿尾灯',
          type: 'image',
          video: '',
          image: 'lightPoint/1/tab1-6.jpg',
          text: ''
        },
        {
          title: '空间',
          type: 'image',
          video: '',
          image: 'lightPoint/2/tab2-5.jpg',
          text: '越级最大1930L后备箱空间'
        }
      ],
      light_point_2:[
        {
          title: '灵犀LED日行灯',
          type: 'image',
          video: '',
          image: 'lightPoint/1/tab1-1.jpg',
          text: ''
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '15.6吋超大2.5K高清屏',
          type: 'image',
          video: '',
          image: 'lightPoint/2/tab2-1.jpg',
          text: '高端科技智慧大屏，享受一场视听盛宴'
        },
        {
          title: 'C-PURE奇瑞净立方绿色座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/2/tab2-4.jpg',
          text: '打造专属“私人氧吧”，全方位守护您和家人的呼吸健康'
        },
        {
          title: 'AI大模型智慧交互',
          type: 'image',
          video: '',
          image: 'lightPoint/2/tab2-6.jpg',
          text: '全时免唤醒，方言免切换，流式语音识别'
        }
      ],
      light_point_2:[
        {
          title: '零重力女王副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/2/tab2-3.jpg',
          text: '最美的女王座椅，躺下就不想离开'
        },
        {
          title: 'SONY 12扬环绕音响',
          type: 'image',
          video: '',
          image: 'lightPoint/2/tab2-2.jpg',
          text: '金耳朵团队专属调音，感受全方位的音效环绕'
        },
        {
          title: '整车软包区域面积78.9%，提供更加舒适的触感，赋予生活更高的品质',
          type: 'image',
          video: '',
          image: 'lightPoint/1/tab1-5.jpg',
          text: ''
        },
        {
          title: '云憩环抱式座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/1/tab1-4.jpg',
          text: ''
        }
      ]
    }
  ],
  tab1:[
    {
      title: '灵犀LED日行灯',
      type: 'image',
      video: '',
      image: 'lightPoint/1/tab1-1.jpg',
      text: ''
    },
    {
      title: '齿刃点阵格栅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/tab1-2.jpg',
      text: ''
    },
    {
      title: '19吋掠影轮毂',
      type: 'image',
      video: '',
      image: 'lightPoint/1/tab1-3.jpg',
      text: ''
    },
    {
      title: '云憩环抱式座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/1/tab1-4.jpg',
      text: ''
    },
    {
      title: '整车软包区域面积78.9%，提供更加舒适的触感，赋予生活更高的品质',
      type: 'image',
      video: '',
      image: 'lightPoint/1/tab1-5.jpg',
      text: ''
    },
    {
      title: '追猎贯穿尾灯',
      type: 'image',
      video: '',
      image: 'lightPoint/1/tab1-6.jpg',
      text: ''
    }
  ],
  tab2: [
    {
      title: '15.6吋超大2.5K高清屏',
      type: 'image',
      video: '',
      image: 'lightPoint/2/tab2-1.jpg',
      text: '高端科技智慧大屏，享受一场视听盛宴'
    },
    {
      title: 'SONY 12扬环绕音响',
      type: 'image',
      video: '',
      image: 'lightPoint/2/tab2-2.jpg',
      text: '金耳朵团队专属调音，感受全方位的音效环绕'
    },
    {
      title: '零重力女王副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/2/tab2-3.jpg',
      text: '最美的女王座椅，躺下就不想离开'
    },
    {
      title: 'C-PURE奇瑞净立方绿色座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/2/tab2-4.jpg',
      text: '打造专属“私人氧吧”，全方位守护您和家人的呼吸健康'
    },
    {
      title: '空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/tab2-5.jpg',
      text: '越级最大1930L后备箱空间'
    },
    {
      title: 'AI大模型智慧交互',
      type: 'image',
      video: '',
      image: 'lightPoint/2/tab2-6.jpg',
      text: '全时免唤醒，方言免切换，流式语音识别'
    }
  ],
  tab3: [
    {
      title: '全栈自研中国心十佳混动发动机',
      type: 'image',
      video: '',
      image: 'lightPoint/3/tab3-1.jpg',
      text: '1200多公里超长综合续航、每1万公里仅需保养一次、三电终身质保'
    }
  ],
  tab4: [
    {
      title: '十佳安全守护，最聪明的磐石车身',
      type: 'image',
      video: '',
      image: 'lightPoint/4/tab4-2.jpg',
      text: '170mm超宽前吸能盒，2.8mm超厚防撞钢梁，航空级铝合金，84%超宽车身横向覆盖率'
    }
  ],
  tab5: [
    {
      title: '全球化设计团队',
      type: 'image',
      video: '',
      image: 'lightPoint/5/1.jpg',
      text: '全球化设计标准， 整车终身质保'
    },
    {
      title: '全球化设计团队',
      type: 'image',
      video: '',
      image: 'lightPoint/5/2.jpg',
      text: '全球化设计标准， 整车终身质保'
    }
  ]
}
